import React from "react";
import OTPInput from "../../components/OtpInput";
import { useForm } from "react-hook-form";
import { LoginStyle } from "./style";
import { useAuth } from "../../common/hooks";
import BouncingDotsLoader from "../../components/DotLoading";
import { Link } from "react-router-dom";

export const OtpScreen = () => {
  const classes = LoginStyle();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { onVerifyOtp, loading } = useAuth();

  const handleVerifyOtp = (event) => {
    const otp = event?.otp;
    if (otp) {
      onVerifyOtp(otp);
    }
  };

  return (
    <div className={classes.loginContainer} style={{ justifyContent: "center", alignItems: "center" }}>
      {/* Decorative layers */}
      <div className={classes.backgroundBlob1} />
      <div className={classes.backgroundBlob2} />
      <div className={classes.particleLayer} />

      <div className={classes.rightPanel} style={{ width: "100%", maxWidth: 500 }}>
        <div className={classes.loginCard} style={{ width: "100%" }}>
          {/* Logo */}
          <div className={classes.logoWrap}>
            <div style={{
              borderRadius: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "fit-content"
            }}>
              <img src="/logo.png" alt="Logo" style={{ height: "120px", width: "auto", objectFit: "contain" }} />
            </div>
          </div>

          {/* Titles */}
          <h2 className={classes.welcomeTitle} style={{ marginTop: 20 }}>Security Verification</h2>
          <p className={classes.subtitle}>
            Enter the OTP sent to your registered email
          </p>

          <form onSubmit={handleSubmit(handleVerifyOtp)} style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <OTPInput
              label=""
              name="otp"
              setValue={setValue}
              register={register}
              validationSchema={{ required: true }}
              errors={errors}
              required
            />

            {/* Verify Button */}
            <button
              type="submit"
              className={classes.loginButton}
              disabled={loading}
              style={{ marginTop: 30 }}
            >
              {loading ? <BouncingDotsLoader /> : <>Verify OTP &nbsp;→</>}
            </button>

            <Link to="/" style={{ color: "#0860D3", fontSize: 14, fontWeight: 600, textDecoration: "none", marginTop: 20 }}>
              ← Back to login
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};
